import axios from 'axios';
import {
  API_GEOMAP_LAST_ISOLINE,
  API_GEOMAP_LAST_POLYGON,
  API_GEOMAP_ISOLINE,
  API_GEOMAP_POLYGON,
  API_GEOMAP_VALID_ISOLINE,
  API_GEOMAP_VALID_POLYGON,
  API_GEOMAP_LAST_BASETIME,
  API_GEOMAP_LAST_VALIDTIME,
  API_GEOMAP_BASETIMES,
  API_GEOMAP_VALIDTIMES,
  API_GEOMAP_VALIDTIMES_BASETIME,
  API_GEOMAP_TERRITORIES
} from '../../constants'

export default {
  state: {
    geoMapIsoLine: [],
    geoMapPolygon: [],
    validtimes: [],
    validtime: null,
    basetime: null,
    basetimes: [],
    territories: [],
    parameters: ['tp'],
  },
  mutations: {
    SET_GEOMAP_ISOLINE: (state, payload) => {
      state.geoMapIsoLine = payload;
    },
    SET_GEOMAP_POLYGON: (state, payload) => {
      state.geoMapPolygon = payload;
    },
    SET_GEOMAP_BASETIME: (state, payload) => {
      state.basetime = payload;
    },
    SET_GEOMAP_VALIDTIME: (state, payload) => {
      state.validtime = payload;
    },
    SET_GEOMAP_BASETIMES: (state, payload) => {
      state.basetimes = payload;
    },
    SET_GEOMAP_VALIDTIMES: (state, payload) => {
      state.validtimes = payload;
    },
    SET_GEOMAP_TERRITORIES: (state, payload) => {
      state.territories = payload;
    },
  },
  actions: {
    FETCH_GEOMAP_LAST_ISOLINE: async (context, payload) => {
      try {
        const url = API_GEOMAP_LAST_ISOLINE(payload.territory, payload.parameter);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_ISOLINE', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_LAST_POLYGON: async (context, payload) => {
      try {
        const url = API_GEOMAP_LAST_POLYGON(payload.territory, payload.parameter);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_POLYGON', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_ISOLINE: async (context, payload) => {
      try {
        const url = API_GEOMAP_ISOLINE(payload.territory, payload.parameter, payload.basetime);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_ISOLINE', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_POLYGON: async (context, payload) => {
      try {
        const url = API_GEOMAP_POLYGON(payload.territory, payload.parameter, payload.basetime);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_POLYGON', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_VALID_ISOLINE: async (context, payload) => {
      try {
        const url = API_GEOMAP_VALID_ISOLINE(payload.territory, payload.parameter, payload.validtimes);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_ISOLINE', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_VALID_POLYGON: async (context, payload) => {
      try {
        const url = API_GEOMAP_VALID_POLYGON(payload.territory, payload.parameter, payload.validtimes);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_POLYGON', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_LAST_BASETIME: async (context, payload) => {
      try {
        const url = API_GEOMAP_LAST_BASETIME(payload.territory, payload.parameter, payload.validtimes);
        let response = await axios.get(url);
        const data = response.data.result;
        context.commit('SET_GEOMAP_BASETIME', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_LAST_VALIDTIME: async (context, payload) => {
      try {
        const url = API_GEOMAP_LAST_VALIDTIME(payload.territory, payload.parameter);
        let response = await axios.get(url);
        const data = response.data.result;
        context.commit('SET_GEOMAP_VALIDTIME', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_BASETIMES: async (context, payload) => {
      try {
        const url = API_GEOMAP_BASETIMES(payload.territory);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_BASETIMES', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_VALIDTIMES: async (context, payload) => {
      try {
        const url = API_GEOMAP_VALIDTIMES(payload.territory, payload.parameter);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_VALIDTIMES', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_VALIDTIMES_BASETIME: async (context, payload) => {
      try {
        const url = API_GEOMAP_VALIDTIMES_BASETIME(payload.territory, payload.parameter, payload.basetime);
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_VALIDTIMES', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
    FETCH_GEOMAP_TERRITORIES: async (context) => {
      try {
        const url = API_GEOMAP_TERRITORIES();
        let response = await axios.get(url);
        const data = response.data.result.data;
        context.commit('SET_GEOMAP_TERRITORIES', data);
        return data;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return [];
      }
    },
  },
  getters: {
    GEOMAP_TERRITORIES: state => {
      return state.territories;
    },
    GEOMAP_POLYGON: state => {
      return state.geoMapPolygon;
    },
    GEOMAP_VALIDTIMES: state => {
      return state.validtimes;
    },
    GEOMAP_VALIDTIME: state => {
      return state.validtime;
    },
    GEOMAP_BASETIME: state => {
      return state.basetime;
    },
    GEOMAP_BASETIMES: state => {
      return state.basetimes;
    },
    GEOMAP_PARAMETERS: state => {
      return state.parameters;
    },

  }
}